/*
 * @Description: 按状态筛选地图成员（顶部状态统计 chip 互斥筛选用）
 */
import { MemberLocationItem } from '../types/cockpit.types'
import { STATUS_KEYS, StatusKey } from '../constants'

/**
 * 按状态键筛选成员列表。
 * 在线/移动中/停留中/离线可直接由 A3 字段推导；异常（abnormal）的成员归属
 * 来自 D/alerts（未结告警），故由 abnormalUserIDs 传入，不依赖 A3 字段。
 *
 * @param members - A3 全员最新位置
 * @param status - 当前选中的状态键；null 表示不筛选
 * @param abnormalUserIDs - 异常成员的 userId 集合（来源 D/alerts）
 * @returns 筛选后的成员列表
 *
 * @example
 * filterMembersByStatus(list, 'moving', []) // 仅在线且移动中的成员
 * filterMembersByStatus(list, null, [])     // 原样返回
 */
export function filterMembersByStatus(
  members: MemberLocationItem[],
  status: StatusKey | null,
  abnormalUserIDs: string[]
): MemberLocationItem[] {
  if (!status) return members

  switch (status) {
    case STATUS_KEYS.ONLINE:
      return members.filter((m) => m.online)
    case STATUS_KEYS.MOVING:
      return members.filter((m) => m.online && m.locationState === 'moving')
    case STATUS_KEYS.STAYING:
      return members.filter((m) => m.online && m.locationState === 'staying')
    case STATUS_KEYS.OFFLINE:
      return members.filter((m) => !m.online)
    case STATUS_KEYS.ABNORMAL:
      return members.filter((m) => abnormalUserIDs.includes(m.userId))
    default:
      return members
  }
}
